module.exports = __webpack_public_path__ + "static/media/imdb-clone.ae9d3b72.png";